import type { Mode } from '@/types'

export const TOKENS: Record<Mode, string> = {
    production: 'phc_Ad5TTroFz0t3Oy00c23a78cHbarjNmhC8ub3soyPPtE',
    sandbox: 'phc_aB1HAIPgiPp2lDCZLN4JwcW1kq3YwcQG6Tfm5dF6hWz',
    staging: 'phc_7ndSXUJo4axwM3KMlJstwGm4mPniewCYuiNqRfBKis',
}

export const LINKS: Record<Mode, string> = {
    staging: 'https://analytics.staging.transactionlink.io',
    sandbox: 'https://analytics.sandbox.transactionlink.io',
    production: 'https://analytics.transactionlink.io',
}

export const POSTHOG_WIDGET_APPS = [
    'widget',
    'edoApp',
    'tlOpenBanking',
    'veriffVideoVerification',
    'veriffAgeEstimation',
    'veriffDocumentCheck',
    'smsApiSmsVerification',
    'przelewy24VerificationPayment',
    'yapilyAisRedirect',
    'customPage',
    'tlCustomForm',
    'zohoSignSignature',
    'complyCubeVideoVerification',
    'tlAppFinish',
    'twilioVerify',
    'gbgIdScan',
    'mobywatel',
    'autopayVerificationPayment',
    'smartId',
    'complyCubeFaceAuthentication',
    'bankIdCzechiaVerification',
    'au10tixVideoVerification',
]
